import SetupAccountModule from '@/modules/setup-account/SetupAccountModule';

export default SetupAccountModule;
